<template>
  <div class="col-12 col-md-12 col-lg-7">
    <div class="tit text-center">
      <p>Por favor, poderia me informar o Patrimônio Líquido da(o) <strong>{{razaoSocial}}</strong>?</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-7 col-xl-7">      
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="celular">Valor em reais</label>
            <input type="text" class="form-control form-control-lg" v-model="patrimonioLiquido" v-mask="'money'" placeholder="R$" v-focus required>
          </div>
          <div class="text-center fixedOptions">
            <button :disabled="patrimonioValido" class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Masker from '@/utils/masker'

export default {
  data(){
    const patrimonioLiquido = this.solicitacao.Empresa.PatrimonioLiquido
    return {
      razaoSocial: this.solicitacao.Empresa.RazaoSocial,
      patrimonioLiquido: patrimonioLiquido ? patrimonioLiquido.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) : null
    }
  },
  computed: {
    patrimonioValido: function() { return parseFloat(this.patrimonioLiquido) <= 0 }
  },
  props: {
    solicitacao: {required: true, type: Object},
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const newData = {
        Empresa: {
          PatrimonioLiquido: Masker.formatReal(this.patrimonioLiquido)
        }
      }
      this.$emit('on-submit', newData)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/NetWorthStep.vue